type LinkConfig = {
  publicKey: string;
  onSuccess: (publicToken?: string) => any;
  onLoad: () => any;
  onExit: (err?: string) => any;
  dev?: {
    openUrl?: string;
  }; // internal use only
  debug?: boolean;
  cardActivationId?: string;
};

type LinkObject = {
  open: any;
  exit: any;
  destroy: any;
};

type PlatformNames =
  | "shopify"
  | "bigcommerce"
  | "etsy"
  | "square"
  | "squarespace"
  | "amazon"
  | "woocommerce"
  | "magento"
  | "shopify"
  | "etsy"
  | "bigcommerce"
  | "big_commerce"
  | "square"
  | "squarespace"
  | "wix"
  | "magento"
  | "woocommerce"
  | "woo_commerce"
  | "amazon"
  | "ebay"
  | "prestashop"
  | "recurly"
  | "stripe"
  | "paypal"
  | "shopee"
  | "shoper"
  | "shopware"
  | "fnac"
  | "lazada"
  | "freshbooks"
  | "quickbooks"
  | "quickbooks_desktop"
  | "xero"
  | "mercadoLibre"
  | "netsuite"
  | "zohobooks"
  | "sagebusinesscloud"
  | "chargebee"
  | "chargify"
  | "sageintacct"
  | "gumroad"
  | "wave"
  | "dynamics365";

type OpenOptions = {
  platform?: PlatformNames;
  storeName?: string; // Only for Shopify
  region?: string; // Only for Amazon
  autoLoad?: boolean;
};

function getNonce(length) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

const WINDOW_WIDTH = 800;
const WINDOW_HEIGHT = 700;

function debugLog(shouldDebug, ...optionalParams: any[]) {
  if (shouldDebug) {
    console.log("[Rutter Link] ", ...optionalParams);
  }
}

var Rutter = {
  create: (
    config: LinkConfig = {
      publicKey: "sandbox_pk_d4b48f90-ff3b-456e-a8e2-1da7af1ab609",
      onSuccess: () => {
        // success
      },
      onLoad: () => {
        // load
      },
      onExit: () => {
        // exit
      },
      debug: false,
    }
  ): LinkObject => {
    // handle passed in variables and initialize Link component
    let openedWindow: any = null;
    return {
      open: (options?: OpenOptions) => {
        debugLog(config.debug, "[trigger] open function called");
        const { onSuccess, onExit, publicKey, dev, cardActivationId } = config;
        let container = document.createElement("span");
        container.className = "selectorgadget_ignore";
        document.body.appendChild(container);
        (window as any).Rutter._rutterContainer = container;
        let authComplete = false;

        debugLog(config.debug, "[Internal] setting backend URI");
        // MUST CALL window.open IMMEDIATELY OTHERWISE POPUP BLOCKED ON MOBILE
        let defaultUrl = "https://production.rutterapi.com";
        if (dev?.openUrl) {
          if (dev?.openUrl) {
            defaultUrl = dev.openUrl;
          } else {
            defaultUrl = "http://localhost:4000";
          }
        }
        debugLog(
          config.debug,
          "[Internal] successfully set backend URI to ",
          defaultUrl
        );
        const nonce = getNonce(5);

        let iframeUri = `${defaultUrl}/linkstart/${publicKey}?token=${publicKey}&origin=${encodeURIComponent(
          window.location.origin
        )}&nonce=${nonce}`;
        if (options?.platform) {
          iframeUri += `&platform=${options.platform}`;
        }
        if (options?.storeName) {
          iframeUri += `&storeName=${options.storeName}`;
        }
        if (options?.region) {
          iframeUri += `&region=${options.region.toUpperCase()}`;
        }
        if (options?.autoLoad) {
          iframeUri += `&autoLoad=true`;
        }
        if (cardActivationId) {
          iframeUri += `&cardActivationId=${cardActivationId}`;
        }
        debugLog(
          config.debug,
          "Generating pop up window with URI: ",
          iframeUri
        );
        const newWindow = popupCenter(
          iframeUri,
          "rutterlinkwindow",
          cardActivationId
            ? { windowWidth: 1200, windowHeight: 800 }
            : undefined
        );
        debugLog(config.debug, "Popup window generated");
        openedWindow = newWindow;
        const popupTick = setInterval(() => {
          if (newWindow?.closed) {
            if (!authComplete && onExit) {
              debugLog(
                config.debug,
                "Popup window closed before authentication completed"
              );
              onExit("MERCHANT_CLOSED");
            }
            debugLog(
              config.debug,
              "[Internal] Removing message event listener"
            );
            window.removeEventListener("message", handleMessage);
            clearInterval(popupTick);
          }
        }, 500);
        function handleMessage(event) {
          if (typeof event.data === "string") {
            try {
              debugLog(
                config.debug,
                "[Internal] Received message from Popup window"
              );
              const parsedMessage = JSON.parse(event.data);
              const { nonce: frameNonce } = parsedMessage;
              if (frameNonce !== nonce) {
                debugLog(
                  config.debug,
                  "[Internal] Nonce mismatch, ignoring message"
                );
                // DIFFERENT Rutter Link window is posting message to this instance of Rutter Link
                return;
              }
              // Handle message (public token only for now)
              const { type } = parsedMessage;
              if (type === "SUCCESS") {
                debugLog(
                  config.debug,
                  "[Internal] Received success message from Popup window"
                );
                const { publicToken } = parsedMessage;
                authComplete = true;
                if (onSuccess) {
                  debugLog(config.debug, "Calling onSuccess callback");
                  onSuccess(publicToken);
                }
              } else if (type === "EXIT") {
                if (onExit) {
                  debugLog(config.debug, "Calling onExit callback");
                  onExit();
                }
                newWindow?.close();
              }
              return;
            } catch (e: any) {
              debugLog(config.debug, "Encountered error", e);
              if (e.message?.includes("Unexpected")) {
                // ignore non JSON messages
                return;
              }
              // link
              if (dev?.openUrl) {
                console.error(e);
              }
            }
            if (onExit) {
              onExit("UNKNOWN_ERROR");
              return;
            }
          }
        }
        window.addEventListener("message", handleMessage);

        // websocket backup connection for cases where window.opener is blocked
        try {
          let defaultWsUrl = "wss://d34w0vr6ge7c9f.cloudfront.net";
          if (dev?.openUrl) {
            defaultWsUrl = "ws://localhost";
          }
          const ws = new WebSocket(
            `${defaultWsUrl}/relay?channelId=${encodeURIComponent(
              nonce
            )}&role=parent`
          );
          ws.addEventListener("open", () => {
            debugLog(config.debug, "wsparent: connected");
          });

          ws.addEventListener("message", (evt) => {
            try {
              const msg = JSON.parse(evt.data);
              const { type } = msg;
              debugLog(
                config.debug,
                "[Internal] Received message from WebSocket"
              );
              const { nonce: frameNonce } = msg;
              if (frameNonce !== nonce) {
                debugLog(
                  config.debug,
                  "[Internal] Nonce mismatch, ignoring message"
                );
                // DIFFERENT Rutter Link window is posting message to this instance of Rutter Link
                return;
              }
              if (type === "SUCCESS") {
                debugLog(
                  config.debug,
                  "[Internal] Received success message from Popup window"
                );
                const { publicToken } = msg;
                authComplete = true;
                if (onSuccess) {
                  debugLog(config.debug, "Calling onSuccess callback");
                  onSuccess(publicToken);
                }
              }
            } catch {
              console.warn("parent: got binary/unknown payload", evt.data);
            }
          });
        } catch (e) {
          debugLog(config.debug, "Error creating WebSocket", e);
        }
      }, // can call openRutter function to do the react stuff
      exit: () => {
        if (openedWindow) {
          openedWindow.close();
        }
        if ((window as any).Rutter._rutterContainer) {
          (window as any).Rutter._rutterContainer.remove();
        }
      },
      destroy: () => {
        if (openedWindow) {
          openedWindow.close();
        }
        if ((window as any).Rutter._rutterContainer) {
          (window as any).Rutter._rutterContainer.remove();
        }
      },
    };
  },
};

(window as any).Rutter = Rutter;
export {}; // Needed to become a module to be imported in react-rutter-link

function popupCenter(url: string, title: string, options?: any) {
  const windowWidth = options?.windowWidth || WINDOW_WIDTH;
  const windowHeight = options?.windowHeight || WINDOW_HEIGHT;
  const y = window.outerHeight / 2 + window.screenY - windowHeight / 2;
  const x = window.outerWidth / 2 + window.screenX - windowWidth / 2;
  return window.open(
    url,
    title,
    `menubar=1, resizable=no, width=${windowWidth}, height=${windowHeight}, top=${y}, left=${x}`
  );
}
